import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Film, Lightbulb, Search, Stethoscope, FileText, ArrowRight } from 'lucide-react';
export function Che2StructureScreen() {
  const flowSteps = [{
    icon: Film,
    label: 'Hook Animation',
    description: "Does your skin feel like it's fighting against you?",
    color: 'bg-purple-50',
    iconColor: 'text-purple-600',
    borderColor: 'border-purple-200'
  }, {
    icon: Lightbulb,
    label: 'Recognition & Symptoms',
    description: 'What is AD? Recognize the signs and symptoms',
    color: 'bg-blue-50',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-200'
  }, {
    icon: Search,
    label: 'Explore Triggers',
    description: 'Understand causes: irritants, allergens, stress, weather',
    color: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    borderColor: 'border-emerald-200'
  }, {
    icon: Stethoscope,
    label: 'Call to Action',
    description: 'Prepare for your healthcare appointment',
    color: 'bg-amber-50',
    iconColor: 'text-amber-600',
    borderColor: 'border-amber-200'
  }, {
    icon: FileText,
    label: 'Discussion Guide (Optional)',
    description: 'Interactive guide to help you talk to your doctor',
    color: 'bg-rose-50/50',
    iconColor: 'text-rose-500',
    borderColor: 'border-rose-300 border-dashed',
    isOptional: true
  }];
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-20" data-id="element-28">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="w-full max-w-6xl" data-id="element-29">
        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-6" data-id="element-30">
          How this applies to Living with AD
        </h2>
        <p className="text-lg text-slate-500 text-center mb-16 max-w-2xl mx-auto" data-id="element-31">
          Progressive engagement flow from awareness to action
        </p>

        <div className="flex flex-col gap-4" data-id="element-32">
          {flowSteps.map((step, index) => <Fragment key={index} data-id="element-33">
              <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.5
          }} className={`${step.color} text-slate-900 border-2 ${step.borderColor} rounded-2xl p-6 md:p-8 flex items-center gap-6 shadow-sm hover:shadow-md transition-shadow relative ${step.isOptional ? 'opacity-90' : ''}`} data-id="element-34">
                {step.isOptional && <div className="absolute -top-3 right-4 bg-rose-100 text-rose-700 text-xs font-bold px-3 py-1 rounded-full border border-rose-200" data-id="element-35">
                    BONUS SNAK
                  </div>}
                <div className={`w-14 h-14 rounded-full bg-white flex items-center justify-center shrink-0 ${step.isOptional ? 'border border-rose-200' : ''}`} data-id="element-36">
                  <step.icon size={28} className={step.iconColor} data-id="element-37" />
                </div>
                <div className="flex-1" data-id="element-38">
                  <h3 className={`font-bold text-xl mb-2 ${step.isOptional ? 'text-slate-700' : ''}`} data-id="element-39">
                    {step.label}
                  </h3>
                  <p className={`text-sm md:text-base text-slate-600`} data-id="element-40">
                    {step.description}
                  </p>
                </div>
                <div className={`hidden md:flex items-center justify-center w-10 h-10 rounded-full bg-white ${step.isOptional ? 'border border-rose-200' : ''}`} data-id="element-41">
                  <span className={`font-bold text-lg text-slate-400`} data-id="element-42">
                    {index + 1}
                  </span>
                </div>
              </motion.div>

              {index < flowSteps.length - 1 && <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15 + 0.1
          }} className="flex justify-center" data-id="element-43">
                  <ArrowRight size={24} className={`rotate-90 ${step.isOptional ? 'text-rose-200' : 'text-slate-300'}`} data-id="element-44" />
                </motion.div>}
            </Fragment>)}
        </div>
      </motion.div>
    </section>;
}